export const SUPPORTED_IMAGE_EXT = ['jpg','jpeg','png']
export const SUPPORT_VIDEO_EXT = ['ogg','mp4','mov']